import React, { useEffect, useState } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { TID } from "@/lib/testIds";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const load = async () => { const { data } = await api.get("/admin/users"); setUsers(data.items); };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const patch = async (uid, payload) => { await api.patch(`/admin/users/${uid}`, payload); toast.success("Updated"); load(); };

  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-10">
        <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Users</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-6">Team & customers.</h1>
        <div className="border border-border bg-white">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left">
              <tr className="text-xs uppercase tracking-widest-2 text-muted-foreground">
                <th className="p-3">Name</th>
                <th className="p-3">Email</th>
                <th className="p-3">Role</th>
                <th className="p-3">Active</th>
                <th className="p-3">Created</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.user_id} className="border-t border-border">
                  <td className="p-3 font-medium">{u.name}</td>
                  <td className="p-3 font-mono text-xs">{u.email}</td>
                  <td className="p-3">
                    <Select value={u.role} onValueChange={(v) => patch(u.user_id, { role: v })}>
                      <SelectTrigger data-testid={`${TID.admin.userRoleSelect}-${u.user_id}`} className="w-36 h-8"><SelectValue /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="customer">Customer</SelectItem>
                        <SelectItem value="analyst">Research Analyst</SelectItem>
                        <SelectItem value="quality">Quality Reviewer</SelectItem>
                        <SelectItem value="finance">Finance</SelectItem>
                        <SelectItem value="admin">Administrator</SelectItem>
                      </SelectContent>
                    </Select>
                  </td>
                  <td className="p-3">
                    <Switch data-testid={`${TID.admin.userActivateToggle}-${u.user_id}`} checked={u.is_active} onCheckedChange={(v) => patch(u.user_id, { is_active: v })} />
                  </td>
                  <td className="p-3 text-xs text-muted-foreground">{new Date(u.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}
